export const INSTAGRAM_LINK = 'https://www.instagram.com/veronika_kubosova/';
